import axios from 'axios';
import { tenantApiBase } from '../context/CompanyContext';
import { handleUnauthorized, isPublicAuthRequest, readAuthData } from '../utils/authStorage';

const rawBaseURL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  'https://hr.adityatrading.in/';

const axiosInstance = axios.create({
  baseURL: rawBaseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Tenant-scoped base ("https://hr.../ats001/"); also used for URLs built by
// hand (e.g. Form 16 PDF links) so they hit this company, not the default.
export const tenantBaseURL = () => tenantApiBase(rawBaseURL);

axiosInstance.interceptors.request.use((config) => {
  config.baseURL = tenantBaseURL();
  try {
    const data = readAuthData();
    const token = data?.admin?.Token || data?.token;
    if (token && !isPublicAuthRequest(config.url)) config.headers.Authorization = `Bearer ${token}`;
  } catch (e) {
    /* malformed authData -> send unauthenticated */
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) handleUnauthorized(error?.config?.url);
    return Promise.reject(error);
  }
);

export default axiosInstance;
